// extracted by mini-css-extract-plugin
module.exports = {"retryLink":"MagicLinkForm_retryLink__CFFOD"};